import { createAuth0 } from "@auth0/auth0-vue";

export const auth = createAuth0({
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    authorizationParams: {
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        scope: import.meta.env.VITE_AUTH0_SCOPE ?? 'profile email',
        redirect_uri: window.location.origin + '/login/auth',
        organization: import.meta.env.VITE_AUTH0_ORG
    }
});
